<template>
    <!-- MYAC-1348 — the chat answers about results and regulation; questions about
         using the platform belong to support. Rendered only when the support chat
         can actually open, so it never promises a channel that is off.

         Hidden rather than disabled, which the header help button next to it is
         NOT (it falls back to the contact dialog): the two are not the same kind
         of control. The help button is the one permanent way to reach a human, so
         it must always do something. This line is an extra pointer on a card that
         is already full of other things to do, and the header is right above it —
         a visibly dead "Contact support" here would be a worse offer than none,
         and the user still has the working one a few pixels away. -->
    <p v-if="isAvailable" class="text-sm text-surface-500 text-center" data-testid="chat-contact-support">
        {{ t('help.support_chat.platform_question') }}
        <button type="button" class="font-semibold text-primary hover:underline" @click="contactSupport">
            {{ t('help.support_chat.contact_support') }}
        </button>
    </p>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAppStore } from '@/stores/app'
import { useSupportChat } from '@/composables/useSupportChat'

const { t } = useI18n()
const appStore = useAppStore()
const { isAvailable, open } = useSupportChat()

// The link is only shown when the chat is configured, so a false here means the
// vendor script failed at click time: say so rather than do nothing.
async function contactSupport() {
    if (await open()) return
    appStore.toast(t('help.support_chat.unavailable_title'), t('help.support_chat.unavailable_detail'), 'warn')
}
</script>
